module.exports = __webpack_public_path__ + "static/media/36x36-13.1fc60c46.png";